module.exports = __webpack_public_path__ + "static/media/dybenko-095.dad61fb3.png";